import { Directive, ElementRef, HostListener, inject } from '@angular/core';
import { MatTooltip } from '@angular/material/tooltip';
import { TranslateService } from '@ngx-translate/core';

@Directive({
  // eslint-disable-next-line @angular-eslint/directive-selector
  selector: '[copyClick]',
  providers: [MatTooltip],
  standalone: true
})
export class CopyOnClickDirective {
  private host = inject<ElementRef<HTMLElement>>(ElementRef);
  private tooltip = inject(MatTooltip);
  private translateService = inject(TranslateService);

  @HostListener('click')
  onClick(): void {
    navigator.clipboard.writeText(this.host.nativeElement.textContent);

    setTimeout(() => {
      this.setTooltip(true);
      this.tooltip.show();
    }, 10);

    setTimeout(() => {
      this.setTooltip(false);
    }, 5000);
  }

  @HostListener('mouseover')
  onMouseOver(): void {
    this.tooltip.show();
  }

  @HostListener('mouseleave')
  onMouseLeave(): void {
    this.tooltip.hide();
  }

  constructor() {
    this.host.nativeElement.style.cursor = 'default';

    this.setTooltip(false);
  }

  private setTooltip(copied: boolean): void {
    this.tooltip.message = this.translateService.instant(
      copied ? 'employee-profile.copied-tooltip' : 'employee-profile.copy-tooltip'
    );
  }
}
